import { Component, OnInit } from "@angular/core";
import { AppComponent } from "./../app.component";
import { Router, ActivatedRoute } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AlertController } from "@ionic/angular";

@Component({
  selector: "app-questions",
  templateUrl: "./questions.page.html",
  styleUrls: ["./questions.page.scss"],
})
export class QuestionsPage implements OnInit {
  constructor(
    private router: Router,
    private http: HttpClient,
    public alertCtrl: AlertController,
    private route: ActivatedRoute,
  ) {
    this.message = null;
    // navigator.geolocation.getCurrentPosition(this.showPosition,this.showError);
    // this.getBrowserInfo();
  }

  otherLoaded = true;
  toggleBool: any = []; // total items selected in checkbox
  inputVal: string = ""; // radio button values
  other: string = "";
  progress = 0;
  setValue = false;

  public AppRef = AppComponent;
  category: string;
  questions: any = [];
  quesCounter: number = 0;
  radValue: string = ""; // Value of 'Radio button'
  answer_template: any = [];
  message: string = "";
  static_hiv: boolean = false;
  static_covid: boolean = false;
  flag: boolean = false; // Prevent the condition : '<div *ngIf="i == quesCounter || (item == questions[i - quesCounter] && flag)" >'
  skip_value: number = 1;
  hide_prev_button: boolean = false;
  hepatitis_static: boolean = false;
  showMention: boolean = false;
  location: any = "";

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.category = params["value"];
    });


    this.loadQuestionnaire(this.category + "/" + this.category + "_" + this.AppRef.currentLang + ".json", this.category)

    /* for particular category data operations */

    if (this.category === "Covid") {
      this.static_covid = true;
    } else if (this.category === "Hepatitis") {
      this.hepatitis_static = true;
    } else if (this.category === "Hiv") {
      this.static_hiv = true;
    }

    // this.api.saveData(JSON.stringify({'test':1}), 'test')
  }

  // load questions func

  loadQuestionnaire(disease: string, header: string) {
    return new Promise((resolve, reject) => {
      this.http.get("assets/selfCheckUp/" + disease).subscribe((res) => {
        this.questions = res[header];
        this.answer_template = [header];
        this.otherLoaded = false;
      });
    });
  }

  // moving questions one by one using this counter

  counter(totalQues: number) {
    this.setValue = false;
    this.hide_prev_button = true;
    this.answer_template.push({

      "input" : this.inputVal,
      "CheckValue" : this.toggleBool,
      "radio Value" : this.radValue,
      "other" : this.other
    });

    if (
      this.static_hiv &&
      this.quesCounter === 0 &&
      !(this.answer_template[1]["radio Value"] === "Never" || this.answer_template[1]["radio Value"] === "कभी नहीँ" || this.answer_template[1]["radio Value"] === "ਕਦੇ ਨਹੀਂ")
    ) {
      this.quesCounter = this.quesCounter + 2;
      this.skip_value = 2; // for **index_maintainance when traverse back**
      this.dummy_answer_template(); // ** sets null values of empty answers which are skipped
    } else if (this.static_hiv &&
      this.quesCounter === 1 &&
      (this.answer_template[1]["radio Value"] === "Never" || this.answer_template[1]["radio Value"] === "कभी नहीँ" || this.answer_template[1]["radio Value"] === "ਕਦੇ ਨਹੀਂ")) {
      this.quesCounter = this.quesCounter + 4;
      this.skip_value = 4;
      this.dummy_answer_template();
      this.dummy_answer_template();
      this.dummy_answer_template();
    }
     else if (this.static_covid === true) {
      // static for **COVID Questionnaire**
      this.quesCounter = this.covid_computation();
    } else if (this.hepatitis_static) {
      this.quesCounter = this.hepatitis_computation();
    } else {
      this.quesCounter = this.quesCounter + 1;
    }

    this.progress = this.quesCounter / totalQues;

    // reset the values of previous state
    this.inputVal = "";
    this.other = "";
    (this.toggleBool = []), (this.radValue = "");
    if (totalQues === this.quesCounter) {
      this.conclude_score(this.answer_template);
    }
  }

  // Go back to **previous question**

  previous() {
    if (this.answer_template.length <= 2 || (this.static_hiv && this.answer_template.length <= 3)) {
      this.hide_prev_button = false;
    }
    this.quesCounter = this.quesCounter - this.skip_value;

    /* 'deletes' last values of answer_template */
    for (var counter: number = 0; counter < this.skip_value; counter++) {
      this.answer_template.splice(-1, 1);
    }
    this.skip_value = 1;
  }

  covid_computation() {
    if (
      this.quesCounter === 10 ||
      this.quesCounter === 13 ||
      this.quesCounter === 17 ||
      this.quesCounter === 20) {
      this.quesCounter = this.quesCounter + this.move_index(this.quesCounter);
    } else {
      this.quesCounter = this.quesCounter + 1;
    }
    return this.quesCounter;
  }

  hepatitis_computation() {
    if (this.quesCounter === 6) {
      if (
        this.answer_template[1]["radio Value"] === "Male"
        ||
        this.answer_template[1]["radio Value"] === "नर"
        ||
        this.answer_template[1]["radio Value"] === "ਮਰਦ"
        ||
        this.answer_template[1]["radio Value"] === "Other"
        ||
        this.answer_template[1]["radio Value"] === "अन्य"
        ||
        this.answer_template[1]["radio Value"] === "ਹੋਰ"
      ) {
        this.quesCounter = this.quesCounter + 3;
        this.skip_value = 3;
        this.dummy_answer_template();
        this.dummy_answer_template();
      } else {
        this.quesCounter = this.quesCounter + 1;
        this.skip_value = 1;
      }
    } else if (this.quesCounter === 7) {
      if (
        (this.answer_template[1]["radio Value"] === "Female" ||
          this.answer_template[1]["radio Value"] === "महिला" ||
          this.answer_template[1]["radio Value"] === "ਰਤ")
        &&
        (this.answer_template[8]["radio Value"] === "No" ||
          this.answer_template[8]["radio Value"] === "नहीं" ||
          this.answer_template[8]["radio Value"] === "ਨਹੀਂ")
      ) {
        this.quesCounter = this.quesCounter + 2;
        this.skip_value = 2;
        this.dummy_answer_template();
      } else {
        this.quesCounter = this.quesCounter + 1;
        this.skip_value = 1;
      }
    } else {
      this.quesCounter = this.quesCounter + 1;
      this.skip_value = 1;
    }
    return this.quesCounter;
  }
  
  move_index(val) {
    let value_count = 1;
    if (this.answer_template[val + 1]["radio Value"] === "No" || this.answer_template[val + 1]["radio Value"] === "नहीं" || this.answer_template[val + 1]["radio Value"] === "ਨਹੀਂ") {
      this.dummy_answer_template();
      this.dummy_answer_template();
      value_count = 3;
    }
    this.skip_value = value_count;
    return value_count;
  }

  dummy_answer_template() {
    this.answer_template.push({
      input: null,
      CheckValue: null,
      "radio Value": null,
    });
  }

  radioValues(event : any) {
    this.radValue = event.target.value;
  }

  // checkbox change Value
  onChange(value: string, isChecked: boolean) {
    this.showMention = false;
    // Empty other state values to disable 'Next' Button
    this.inputVal = "";
    this.radValue = "";

    if (value === "None" || value === "कोई नहीं" || value === 'ਕੋਈ ਨਹੀਂ' || value === "Don’t know" || value === "नहीं मालूम" || value === "ਨਹੀਂ ਪਤਾ") {
      this.setValue = !this.setValue;
      this.toggleBool = []
      this.showMention = false;
    }

    if(value === 'Children with other risk factors, please specify' || value === 'Adults with other risk factors, please specify'
    || value === 'अन्य जोखिम कारकों वाले वयस्क, कृपया निर्दिष्ट करें' || 
    value === 'अन्य जोखिम कारकों वाले बच्चे, कृपया निर्दिष्ट करें' ||
     value === 'ਖਤਰੇ ਦੇ ਹੋਰ ਕਾਰਕਾਂ ਵਾਲੇ ਬਾਲਗ, ਕਿਰਪਾ ਕਰਕੇ ਵਰਣਨ ਕਰੋ' || 
     value === 'ਖਤਰੇ ਦੇ ਹੋਰ ਕਾਰਕਾਂ ਵਾਲੇ ਬੱਚੇ, ਕਿਰਪਾ ਕਰਕੇ ਵਰਣਨ ਕਰੋ')
    if(isChecked) {
      this.toggleBool = []
      this.showMention = true;
    } else if(!isChecked) {
      this.showMention = false;
    }

    if (isChecked) {
      this.toggleBool.push(value);
    } else {
      let index = this.toggleBool.indexOf(value);
      this.toggleBool.splice(index, 1);
    }
  }

  conclude_score(data: any) {

    this.hide_prev_button = false;
    let header = data[0];
    const fine = this.AppRef.content.ques_message[this.AppRef.currentLang]['allWell'];
    console.log("data", data);

    this.sendResponseToServer(data,header);

    if (header === "TbA" || header === "TbC" || header === "TbP") {

      if (data[1]["radio Value"] === "< 20"
        &&
        (data[2]["radio Value"] === "No" || data[2]["radio Value"] === "नहीं" || data[2]["radio Value"] === "ਨਹੀਂ")
        &&
        !(data[5]["CheckValue"][0] === 'None' || data[5]["CheckValue"][0] === 'कोई नहीं' || data[5]["CheckValue"][0] === 'ਕੋਈ ਨਹੀਂ')
      ) {
        this.message = this.AppRef.content.ques_message[this.AppRef.currentLang]['tb'];
      }
      else if (
        (!(data[3]["CheckValue"][0] === 'None' || data[3]["CheckValue"][0] === 'कोई नहीं' || data[5]["CheckValue"][0] === 'ਕੋਈ ਨਹੀਂ')
          &&
          (data[6]["radio Value"] === "Yes" || data[6]["radio Value"] === "हाँ" || data[6]["radio Value"] === "ਹਾਂ"))
        ||
        ((data[7]["radio Value"] === "Yes" || data[7]["radio Value"] === "हाँ" || data[7]["radio Value"] === "ਹਾਂ")
          &&
          (data[8]["radio Value"] === "Yes" || data[8]["radio Value"] === "हाँ" || data[8]["radio Value"] === "ਹਾਂ"))
      ) {
        this.message = this.AppRef.content.ques_message[this.AppRef.currentLang]['tb'];
      } else {
        this.message = fine;
      }
    }

    else if (header === "Hepatitis") {

      if (
        (data[4]["radio Value"] === "Yes" || data[4]["radio Value"] === "हाँ" || data[4]["radio Value"] === "ਹਾਂ")
        ||
        (data[6]["radio Value"] === "Yes" || data[6]["radio Value"] === "हाँ" || data[6]["radio Value"] === "ਹਾਂ")
        ||
        (data[7]["radio Value"] === "Yes" || data[7]["radio Value"] === "हाँ" || data[7]["radio Value"] === "ਹਾਂ")
        ||
        // this is to check if pregnant 
        (data[8]["radio Value"] === "Yes" || data[8]["radio Value"] === "हाँ" || data[8]["radio Value"] === "ਹਾਂ")
        ||
        (data[9]["radio Value"] === "Yes" || data[9]["radio Value"] === "हाँ" || data[9]["radio Value"] === "ਹਾਂ")
        ||
        (data[10]["radio Value"] === "Yes" || data[10]["radio Value"] === "हाँ" || data[10]["radio Value"] === "ਹਾਂ")
        ||
        (data[11]["radio Value"] === "Yes" || data[11]["radio Value"] === "हाँ" || data[11]["radio Value"] === "ਹਾਂ")
        ||
        (data[12]["radio Value"] === "Yes" || data[12]["radio Value"] === "हाँ" || data[12]["radio Value"] === "ਹਾਂ")
        ||
        (data[13]["radio Value"] === "Yes" || data[13]["radio Value"] === "हाँ" || data[13]["radio Value"] === "ਹਾਂ")
      ) {
        this.message = this.AppRef.content.ques_message[this.AppRef.currentLang]['hepatitis'];
      } else {
        this.message = fine;
      }
    }
    else if (header === "Hiv") {

      if (
        (this.answer_template[1]["radio Value"] === "Never" || this.answer_template[1]["radio Value"] === "ਕਦੇ ਨਹੀਂ" || this.answer_template[1]["radio Value"] === "कभी नहीँ")
        &&
        !(this.answer_template[6]['CheckValue'][0] === "None" || this.answer_template[6]['CheckValue'][0] === "कोई नहीं" || this.answer_template[6]['CheckValue'][0] === "ਕੋਈ ਨਹੀਂ")
      ) {
        this.message = this.AppRef.content.ques_message[this.AppRef.currentLang]['hiv_low'];
      } else if (
        !(this.answer_template[1]["radio Value"] === "Never" || this.answer_template[1]["radio Value"] === "ਕਦੇ ਨਹੀਂ" || this.answer_template[1]["radio Value"] === "कभी नहीँ")
        &&
        !(this.answer_template[6]['CheckValue'][0] === "None" || this.answer_template[6]['CheckValue'][0] === "कोई नहीं" || this.answer_template[6]['CheckValue'][0] === "ਕੋਈ ਨਹੀਂ")
      ) {
        this.message = this.AppRef.content.ques_message[this.AppRef.currentLang]['hiv_med'];
      } else {
        this.message = fine;
      }
    }
    else if (header === "Covid") {

      if (
        (
          (data[11]["radio Value"] === "Yes" || data[11]["radio Value"] === "हाँ" || data[11]["radio Value"] === "ਹਾਂ") 
          &&
          !(this.answer_template[13]['CheckValue'][0] === "None" || this.answer_template[13]['CheckValue'][0] === "कोई नहीं" || this.answer_template[13]['CheckValue'][0] === "ਕੋਈ ਨਹੀਂ"))
        ||
        ((data[14]["radio Value"] === "Yes" || data[14]["radio Value"] === "हाँ" || data[14]["radio Value"] === "ਹਾਂ") 
        &&
          !(this.answer_template[16]['CheckValue'][0] === "None" || this.answer_template[16]['CheckValue'][0] === "कोई नहीं" || this.answer_template[16]['CheckValue'][0] === "ਕੋਈ ਨਹੀਂ"))
        ||
        ((data[18]["radio Value"] === "Yes" || data[18]["radio Value"] === "हाँ" || data[18]["radio Value"] === "ਹਾਂ") &&
          !(this.answer_template[20]['CheckValue'][0] === "None" || this.answer_template[20]['CheckValue'][0] === "कोई नहीं" || this.answer_template[20]['CheckValue'][0] === "ਕੋਈ ਨਹੀਂ"))
        ||
        (data[21]["radio Value"] === "Yes" || data[21]["radio Value"] === "हाँ" || data[21]["radio Value"] === "ਹਾਂ")
        ||
        (data[23]["radio Value"] === "Yes" || data[23]["radio Value"] === "हाँ" || data[23]["radio Value"] === "ਹਾਂ")
      ) {
        this.message = this.AppRef.content.ques_message[this.AppRef.currentLang]['covid_high'];
      } else if (
        (data[10]["radio Value"] === "Yes" || data[10]["radio Value"] === "हाँ" || data[10]["radio Value"] === "ਹਾਂ")
        ||
        !(this.answer_template[9]['CheckValue'][0] === "None" || this.answer_template[9]['CheckValue'][0] === "कोई नहीं" || this.answer_template[9]['CheckValue'][0] === "ਕੋਈ ਨਹੀਂ")
      ) {
         this.message = this.AppRef.content.ques_message[this.AppRef.currentLang]['covid_med'];
      } else {
        this.message = fine;
      }
    }
  }

  sendResponseToServer(answersCoded, header) {
   const info = this.getBrowserInfo();
   console.log(answersCoded);
   console.log(this.questions);
    const data = [];
    for (let i = 0; i < this.questions.length; i++) {
      const temp = {
          question: this.questions[i].question,
          answer: answersCoded[i+1].CheckValue && answersCoded[i+1].CheckValue.length > 0 ? answersCoded[i+1].CheckValue : answersCoded[i+1]["radio Value"],
      }
      if(answersCoded[i+1].input || answersCoded[i+1].other) 
        temp['mention'] = answersCoded[i+1].input || answersCoded[i+1].other;
      data.push(temp);
    }
    console.log(data);
    this.http
      .post(AppComponent.base + "/surveys", {
        data : {
           filledInfo: data,
           browserInfo: info
        }
      })
      .subscribe((r) => {
      }, (e) => {
        console.log(e)
      });
  }

  home() {
    this.router.navigate(["/tabs"]);
  }

   getBrowserInfo() {
    let ip = {}
    // this.http.get('https://api.ipify.org/').subscribe((r) => {
    //   console.log(r);
    //   ip = r;
    // }, (e) => {
    //   console.log(e);
    // });
    // this.http.get('https://api.hackertarget.com/geoip/?q=49.36.211.184').subscribe((r) => {
    //   ip = r;
    // }, (e) => {
    //   console.log(e);
    // });
    const info =  {
      'agent': navigator.userAgent,
      'platform': navigator.platform,
      'language': navigator.language,
      'cookiesEnabled': navigator.cookieEnabled,
      'timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
    }
      // 'coordinates': JSON.stringify(ip)
    return info;
}

showPosition(position){
  var lat = position.coords.latitude;
  var lon = position.coords.longitude;
  return {lat, lon};
}

showError(error){
  switch(error.code){
      case error.PERMISSION_DENIED:
          console.log("User denied the request for Geolocation.")
      break;
      case error.POSITION_UNAVAILABLE:
        console.log("Location information is unavailable.")
      break;
      case error.TIMEOUT:
        console.log("The request to get user location timed out.")
      break;
      case error.UNKNOWN_ERROR:
        console.log("An unknown error occurred.")
      break;
  }
}

}
